<template>
  <div>
    <el-table
      :data="userList"
      height="calc(100vh - 380px)"
      :row-class-name="tableRowClassName"
    >
      <!-- <el-table-column label="用户账户">
        <template slot-scope="scope">{{ scope.row.accountName }}</template>
      </el-table-column> -->

      <!-- <el-table-column prop="userType" label="用户身份">
        <template slot-scope="scope">
          <span v-if="scope.row.userType == '普通用户'" class="red">{{
            scope.row.userType
          }}</span>
          <span v-else class="cc">{{ scope.row.userType }}</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="userId" label="用户UID">
        <template slot-scope="scope">
          <span
            @click="showBox(scope.row, 2)"
            :class="{
              tdRed: scope.row.mark == true,
              blue: scope.row.mark != true,
              myTd: true,
            }"
            >{{ scope.row.userId }}</span
          >
        </template>
      </el-table-column>

      <el-table-column prop="userTypeName" label="用户类型" align="center" min-width="120" />

      <el-table-column prop="channelUserId" label="合伙人UID" align="center">
        <template slot-scope="scope">
          <span @click="showBox(scope.row, 1)" class="myTd blue">{{
            scope.row.channelUserId
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="tradeAmount" label="总成交额" align="center">
        <template slot-scope="scope">
          {{ scope.row.tradeAmount }}
        </template>
      </el-table-column>
      <el-table-column label="总手续费" align="center">
        <template slot-scope="scope">{{ scope.row.fee }}</template>
      </el-table-column>
      <el-table-column label="总结算盈亏" align="center">
        <template slot-scope="scope">
          {{ scope.row.profit }}
        </template>
      </el-table-column>
      <el-table-column label="总净盈亏" align="center">
        <template slot-scope="scope">
          {{ scope.row.purenessProfit }}
        </template>
      </el-table-column>

      <el-table-column label="总充值" align="center" prop="deposit" />
      <el-table-column label="总提现" align="center" prop="withdraw" />
      <el-table-column label="净充值" align="center" prop="recharge" />
      <!-- <el-table-column  label="是否展示备注">
        <template slot-scope="scope">
          <span v-if="scope.row">{{ scope.row.type}}</span>
        </template>
      </el-table-column> -->

      <!-- <el-table-column label="操作" >
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="goDetail(scope.row)">资产明细</el-button>
          <el-button size="mini" type="text" @click="handleUpdate(scope.row)" v-if="scope.row.type==0"
            >修改备注</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <div class="pag">
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="pageChanged"
      ></pagination>
    </div>
    <!-- <update-dialog
      :val="userinfoDetail"
      :updateForm="updateForm"
    ></update-dialog> -->

    <!-- 编辑用户信息dialog -->
    <el-dialog
      title="修改备注"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <div class="main">
        <el-card class="box-card">
          <div>备注信息</div>
          <div class="content">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入备注信息"
              maxlength="50"
              show-word-limit
              v-model="textarea2"
            >
            </el-input>
          </div>
          <div class="btn">
            <el-button size="mini" type="primary" @click="add"
              >添 加</el-button
            >
          </div>
        </el-card>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span> -->
    </el-dialog>
    <UserDetailDialog :id="id" :type="type" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import Pagination from "components/pagination";
import updateDialog from "../updatedialog";
import UserDetailDialog from "components/userDetailDialog";

export default {
  name: "UserList",
  data() {
    return {
      updateForm: {},
      updateUserTypeDialogVisible: false,
      newUserType: "",
      selectedForUserType: {},
      centerDialogVisible: false,
      textarea2: "",
      type: "",
      id: "",
    };
  },
  components: {
    Pagination,
    updateDialog,
    UserDetailDialog,
  },
  methods: {
    ...mapActions("transcationSummary", ["addRemark"]),
    ...mapMutations("transcationSummary", [
      "setUserinfoDetailDialogVisible",
      "setUserinfoDetail",
    ]),
    ...mapMutations("contractassets", ["setUserDetailInfoVisible"]),

    pageChanged(pagination) {
      this.$emit("refresh", pagination);
    },
    handleUpdate(row) {
      this.updateForm = row;
      // this.setUserinfoDetail(row);
      // this.setUserinfoDetailDialogVisible(true);
      this.centerDialogVisible = true;
      this.textarea2 = row.remarks;
    },
    add() {
      this.addRemark({
        channelId: this.userInfo.channelId,
        userId: this.updateForm.id,
        remarks: this.textarea2,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success("添加成功");
          (this.textarea2 = ""), (this.centerDialogVisible = false);
          this.$emit("refresh");
        }
      });
    },
    goDetail(row) {
      this.$router.push({
        path: `/home/transcationSummary/detail`,
        query: row,
      });
    },
    showBox(row, type) {
      this.type = type;
      this.id = type == 2 ? row.userId : row.channelUserId;
      this.setUserDetailInfoVisible(true);
    },
    tableRowClassName({ row }) {
      if (row.mark == true) {
        return "redRow";
      }
      return "";
    },
  },
  computed: {
    // ...mapGetters('user', ['userList']),
    ...mapState(["userInfo"]),
    ...mapState("transcationSummary", [
      "pagination",
      "userList",
      "totalCount",
      "userinfoDetail",
      "userinfoDetailDialogVisible",
    ]),
  },
};
</script>

<style lang="less" src="../../../../../styles/table.less" scoped></style>
